import easydropdown from 'easydropdown'

const navDropdown = 'js-navigation-dropdown'
const submitDropdown = 'js-submit-dropdown'

const $dropdowns = document.querySelectorAll('.form--styled select.dropdown')

const state = {
  dropdownMutationObserver: null
}

const fn = {
  init: () => {
    state.dropdownMutationObserver = new MutationObserver(fn.dropdownMutationCallback)

    $dropdowns.forEach(($el) => {
      if (!$el.querySelector('[selected]')) {
        $el.selectedIndex = -1
      }

      fn.setupDropdown($el)
    })
  },

  setupDropdown: ($el) => {
    if ($el.tagName !== 'SELECT') {
      return
    }

    const opts = {
      behavior: {
        openOnFocus: true,
        maxVisibleItems: 8,
        liveUpdates: true
      }
    }

    if ($el.classList.contains(navDropdown)) {
      opts.callbacks = {
        onSelect: value => window.location.href = value
      }
    }

    if ($el.classList.contains(submitDropdown)) {
      opts.callbacks = {
        onSelect: () => $el.closest('form').submit()
      }
    }

    const $form = $el.closest('form')
    const $placeholder = $el.querySelector('option[value=""]')

    if ($placeholder && !$placeholder.hasAttribute('data-placeholder')) {
      $placeholder.setAttribute('data-placeholder', true)
      $placeholder.textContent = 'Select One'
    }

    if (!$placeholder) {
      $($el).prepend('<option value="" data-placeholder>Select One</option>')
    }

    easydropdown($el, opts)

    const $fieldWrapper = $el.closest('.field__wrapper')

    if ($el.closest('form').classList.contains('userform')) {
      state.dropdownMutationObserver.observe($fieldWrapper, {
        attributes: false,
        childList: true,
        subtree: true
      })
    }
  },

  // Fix for Userform's validation errors with easydropdown
  dropdownMutationCallback: (mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type == 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.classList && node.classList.contains('error') && !node.classList.contains('error-fix')) {
            const $targetParent = node.closest('.middleColumn')

            if ($targetParent) {
              node.classList.add('error-fix')
              $targetParent.appendChild(node)
            }
          }
        })
      }
    }
  }
}

export const StyledDropdown = {
  init: ($el) => {
    fn.setupDropdown($el)
  }
}

export default {
  can: () => $dropdowns.length,
  run: fn.init
}
